import { useState } from "react";
import { GameState } from "../App";
import "./Treasure-Chest.scss";

interface TreasureProps {
  setGameState: (gameState: GameState) => void;
  firstText: string;
}

export const TreasureChest: React.FC<TreasureProps> = ({
  setGameState,
  firstText,
}) => {
  const [key1, setKey1] = useState(0);
  const [key2, setKey2] = useState(0);
  const [key3, setKey3] = useState(0);
  const [key4, setKey4] = useState(0);
  const [key5, setKey5] = useState(0);

  const changeKey = (e: string, keyNum: number) => {
    const entered: number = +e;
    switch (keyNum) {
      case 1:
        setKey1(entered);
        break;
      case 2:
        setKey2(entered);
        break;
      case 3:
        setKey3(entered);
        break;
      case 4:
        setKey4(entered);
        break;
      case 5:
        setKey5(entered);
        break;
      default:
        alert("how did you get here");
        break;
    }
  };

  const attemptOpen = () => {
    if (key1 === 0 && key2 === 3 && key3 === 4 && key4 === 2 && key5 === 7) {
      setGameState("victory");
    } else {
      setGameState("reset");
    }
  };

  return (
    <div className="final-challenge">
      <div className="question-1">{firstText}</div>
      <div className="fancy-text">
        Only your journey's answers will reveal the destination
      </div>
      <div className="question-2">What do you enter as the code?</div>
      <div className="padlock">
        <input
          type="text"
          value={key1}
          onChange={(e) => changeKey(e.target.value, 1)}
        />
        <input
          type="text"
          value={key2}
          onChange={(e) => changeKey(e.target.value, 2)}
        />
        <input
          type="text"
          value={key3}
          onChange={(e) => changeKey(e.target.value, 3)}
        />
        <input
          type="text"
          value={key4}
          onChange={(e) => changeKey(e.target.value, 4)}
        />
        <input
          type="text"
          value={key5}
          onChange={(e) => changeKey(e.target.value, 5)}
        />
      </div>
      <button className={"open"} onClick={attemptOpen}>
        Open the lock!
      </button>
    </div>
  );
};
